<div class="wrapper">
    <div class="section-space"></div>
    <app-headers></app-headers>
    <app-features></app-features>
    <app-teams></app-teams>
    <app-contacts id="get-in-touch"></app-contacts>
    <app-footer-main></app-footer-main>
</div>
